import { LicenseInfo } from '@mui/x-license'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import ReactDOM from 'react-dom/client'
import { ThemeProviderContext, ThemeProviderWrapper } from 'theme'
import './index.css'
import Main from './Main'

LicenseInfo.setLicenseKey(
  // 'c1b224b295a305fa98a7ddc8b19b8141Tz05MTg5NyxFPTE3NDkxMzgwOTAwMDAsUz1wcm8sTE09cGVycGV0dWFsLEtWPTI='
  // 'ca088f1b30d080ba7a3392c59948aeccTz0xMTUyNjgsRT0xNzgyNjA0Nzk5MDAwLFM9cHJvLExNPXBlcnBldHVhbCxQVj1RMy0yMDI0LEtWPTI='
  'e69de6e15c11a7073f8a94b043efee06Tz0xMTY1MTEsRT0xNzgyNjA0Nzk5MDAwLFM9cHJlbWl1bSxMTT1wZXJwZXR1YWwsUFY9aW5pdGlhbCxLVj0y'
)

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: Infinity, // Prevent all queries from becoming stale
      gcTime: 1000 * 60 * 30, // Cache for 30 minutes test
      refetchOnWindowFocus: false, // Disable refetching on window focus
      refetchOnReconnect: false, // Disable refetching on reconnect
    },
  },
})
const App = () => {
  return (
    <ThemeProviderWrapper>
      <QueryClientProvider client={queryClient}>
        {/* <QueryDataDebugger /> */}
        <Main />
        <ReactQueryDevtools initialIsOpen={false} buttonPosition={'bottom-right'} />
      </QueryClientProvider>
    </ThemeProviderWrapper>
  )
}
const root = ReactDOM.createRoot(document.getElementById('root'))
localStorage.setItem('debugLogs', '1')
// localStorage.setItem('debugLogs', '0')
const _debugEnabled = typeof window !== 'undefined' && localStorage.getItem('debugLogs') === '1'
root.render(
  <ThemeProviderContext>
    <App />
  </ThemeProviderContext>
)
